package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecordViewRequest(
    @SerialName("target_type") val targetType: AdminTargetType,
    @SerialName("target_id") val targetId: String,
)
